export default "__VITE_ASSET__28f4ae10__"